import React from 'react';
import PropTypes from 'prop-types';
import { SovosReadOnlySlidingPanel } from 's1-ui/sovos-sliding-panel';
import SovosButtonsGroup from 's1-ui/sovos-buttons-group/SovosButtonsGroup';
import SovosRaisedButton from 's1-ui/sovos-raised-button/SovosRaisedButton';
import FilterItem from 'shared/components/filterItem/FilterItem';
import { white, purpleDecorations } from 'theme/mainColors';
import './invoiceLineFilterSlidingPage.scss';

class InvoiceLinesFilterSlidingPanel extends React.Component {
  handleCloseSlidingPanel = () => {
    this.props.invoiceLinesFiltersActions.restoreInvoiceLineFilters();
    this.props.onClose();
  };

  handleApplyClick = () => {
    this.props.invoiceLinesFiltersActions.applyFilters();
    this.props.onClose();
  };

  handleClearClick = () => this.props.invoiceLinesFiltersActions.clearAllInvoiceLineFilters();

  handleExpandClick = filter => this.props.invoiceLinesFiltersActions.expandInvoiceLineFilter(filter);

  handleCollapseClick = filter => this.props.invoiceLinesFiltersActions.clearInvoiceLineFilter(filter);

  handleFieldChange = (ev, value, filter) => {
    const filterKey = ev.target.name;
    this.props.invoiceLinesFiltersActions.setFilterValue(filterKey, filter.data.type, value);
  };

  render () {
    const { title, open, baseWidth, tempFilters } = this.props;
    return (
      <SovosReadOnlySlidingPanel
        title={ title }
        open={ open }
        onClose={ this.handleCloseSlidingPanel }
        baseWidth={ baseWidth }
        className="line-filter__sliding-panel"
        additionalButtons={ [
          <SovosButtonsGroup 
            key="filter-additional-action-buttons" 
            align="center"
            className="filter-additional-action-button"
          >
            <SovosRaisedButton
              key="apply-button"
              color={ white }
              backgroundColor={ purpleDecorations }
              onClick={ this.handleApplyClick }
            >
              APPLY
            </SovosRaisedButton>
            <SovosRaisedButton
              key="cancel-button"
              color={ purpleDecorations }
              backgroundColor={ white }
              onClick={ this.handleClearClick }
            >
              CLEAR
            </SovosRaisedButton>
          </SovosButtonsGroup>
        ] }
      >
        {
          tempFilters.map(filter => (
            <FilterItem
              key={ filter.data.key || filter.data.min.key }
              filter={ filter }
              onCollapse={ () => this.handleCollapseClick(filter) }
              onExpand={ () => this.handleExpandClick(filter) }
              onFieldChange={ (ev, value) => this.handleFieldChange(ev, value, filter) }
            />
          ))
        }
      </SovosReadOnlySlidingPanel>
    );
  }
}

InvoiceLinesFilterSlidingPanel.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  baseWidth: PropTypes.string,
  title: PropTypes.string.isRequired,
  tempFilters: PropTypes.array.isRequired,
  invoiceLinesFiltersActions: PropTypes.shape({
    applyFilters: PropTypes.func,
    expandInvoiceLineFilter: PropTypes.func,
    clearInvoiceLineFilter: PropTypes.func,
    restoreInvoiceLineFilters: PropTypes.func,
    clearAllInvoiceLineFilters: PropTypes.func,
    setFilterValue: PropTypes.func
  }).isRequired
};

export default InvoiceLinesFilterSlidingPanel;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesGrid/c/invoiceLinesFilters/InvoiceLinesFiltersSlidingPanel.js